export default "__VITE_ASSET__PXYTTH1N__"